import { useEffect, useRef } from 'react';

const useAnimation = (data, key, setAnimatedState) => {
  const previousValues = useRef({});

  useEffect(() => {
    const intervals = [];

    data.forEach((item) => {
      let start = previousValues.current[item.id] || 0;
      const end = item[key] || 0;
      const duration = 2000;
      const stepTime = 50;
      const steps = duration / stepTime;
      const difference = end - start;
      const increment = difference / steps;

      if (start === end) {
        setAnimatedState((prev) => ({
          ...prev,
          [item.id]: end,
        }));
        return;
      }

      const interval = setInterval(() => {
        start += increment;

        const isFinished = increment >= 0 ? start >= end : start <= end;

        const currentValue = isFinished ? end : Math.round(start);

        setAnimatedState((prev) => ({
          ...prev,
          [item.id]: currentValue,
        }));

        if (isFinished) {
          previousValues.current[item.id] = end;
          clearInterval(interval);
        }
      }, stepTime);

      intervals.push(interval);
    });

    return () => intervals.forEach(clearInterval);
  }, [data]);
};

export default useAnimation;
